import React from "react";
import { Helmet } from "react-helmet";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slick from "../components/Slick";
import "./AboutUs.css";
import WorldMap from "../assets/image/AU_MAP.png";
function AboutUs() {
  return (
    <div>
      <Helmet>
        <title>Engineering your magic Since 2015 | Riocube Engineering</title>
        <meta
          name="description"
          content="From control systems to animatronics, Riocube Engineering has been crafting magical experiences for themed entertainment since 2015."
        />
        <meta name="keywords" content="" />
      </Helmet>
      <Header />
      <Slick />
      <section className="hero-banner-A-2">
        <header className="brand-header">
          <h1>RIOCUBE CARES</h1>
          <div className="control-bar-A">
            <div className="control-button-A">
              <span style={{ color: "#659f4c" }}>C</span>ontrols
            </div>
            <div className="control-button-A">
              <span style={{ color: "#E49E20" }}>A</span>nimatronics
            </div>
            <div className="control-button-A">
              <span style={{ color: "#01488C" }}>R</span>ides Service
            </div>
            <div className="control-button-A">
              <span style={{ color: "#E49E20" }}>E</span>ffects and{" "}
              <span style={{ color: "#E49E20" }}>S</span>cenic
            </div>
          </div>
        </header>
        <div className="layout-container">
          <div className="map-column">
            <img
              src={WorldMap}
              alt="Global Offices Distribution"
              className="map-visual"
              loading="lazy"
            />
          </div>

          <div className="info-column">
            <div className="office-card">
              <h3>Riocube Beijing</h3>
              <div className="contact-line">Woody Ming Zhang</div>
              <div className="email-line">wmzhang@riocube.com</div>
              <h3>Riocube Langfang Workshop</h3>
              <h3>X Cube Shanghai</h3>
              <div className="contact-line">Sean Lim</div>
              <div className="email-line">Sean.lim@riocube.com</div>
              <h3>X Cube Shanghai Workshop</h3>
              <h3>Riocube Singapore</h3>
              <div className="contact-line">Wilma Wang</div>
              <div className="email-line">wilma.wang@riocube.com</div>
              <h3>Riocube Orlando</h3>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default AboutUs;
